import React from 'react';
import { flushSync } from 'react-dom';
import { get } from 'lodash-es';
import { getSearchParamValue } from '@/util/helper/searchParams';
import { useRouter } from '@/util/hook/custom';
import useDispatch from '@/util/hook/useDispatch';
import useEffect from '@/util/hook/useEffect';
import useState from '@/util/hook/useState';
import { authLiffIdInit, authLogSessionTokenInit } from '@/util/redux/auth';
import { initAPI } from '@/api/careClientVisitor';
import { sessionAPI } from '@/api/log';
import { COMMON_ROUTES } from '@/config/route';
import { APP } from '../../../config/app';
import RWDPageLayout from '../../composite/RWDPageLayout';
const ENTRY_POINT_TRACKER_ID_SEARCH_PARAM = 'epid';
const useInitCareClientVisitorAndLogSession = ({ dispatch, navigateError, setIsLoading, }) => {
    useEffect(() => {
        (async () => {
            // 1. Init careClientVisitor
            const entryPointTrackerId = getSearchParamValue({
                paramKey: ENTRY_POINT_TRACKER_ID_SEARCH_PARAM,
            });
            const res = await initAPI.Init({ entryPointTrackerId });
            const careClientVisitorId = get(res, 'data.careClientVisitorId', '');
            if (!res.success || !careClientVisitorId) {
                navigateError(res.errorCode, COMMON_ROUTES.API_ERROR);
                setIsLoading(false);
                return;
            }
            flushSync(() => {
                // #NOTES
                // We currently treat careClientVisitorId as the same as liffId.
                // A better approach is to rename liffId to fit a wider purpose
                dispatch(authLiffIdInit(careClientVisitorId));
            });
            // if ENV is local, skip log session init
            if (process.env.ENV.TARGET_ENV === 'local') {
                setIsLoading(false);
                return;
            }
            // 2. Init log session
            const userAgent = get(window, 'navigator.userAgent');
            const params = {
                _id: careClientVisitorId,
                appName: APP.NAME,
                appVersionCommitSHA: APP.VERSION_COMMIT_SHA,
                appBuildDate: APP.BUILD_DATE,
                userAgent,
            };
            const logSessionInitRes = await sessionAPI.Init(params);
            if (logSessionInitRes.success) {
                const logSessionToken = get(logSessionInitRes, 'data.token', '');
                dispatch(authLogSessionTokenInit(logSessionToken));
            }
            setIsLoading(false);
        })();
    }, []);
};
export default function AuthInitProvider({ children }) {
    const [isLoading, setIsLoading] = useState(true);
    const { navigateError } = useRouter();
    const dispatch = useDispatch();
    useInitCareClientVisitorAndLogSession({
        dispatch,
        navigateError,
        setIsLoading,
    });
    // #NOTES
    // render children after the careClientVisitor is initialized
    // to make sure _id is available for the children
    return isLoading ? <RWDPageLayout isLoading/> : children;
}
